module.exports = __webpack_public_path__ + "media/images/expert__dani-kern-f0780197f5164e8209fd802a71eb8456.png";